import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { EllipsisText, Group, List } from '@coveord/plasma-mantine';
import classes from './PromptList.module.css';
export var PromptListItem = function PromptListItem(param) {
    var label = param.label, descriptor = param.descriptor;
    return /*#__PURE__*/ _jsx(List.Item, {
        children: /*#__PURE__*/ _jsxs(Group, {
            gap: "xxs",
            wrap: "nowrap",
            children: [
                /*#__PURE__*/ _jsx(EllipsisText, {
                    fw: 500,
                    lineClamp: 1,
                    maw: "100%",
                    classNames: {
                        root: classes.ellipsisTextRoot
                    },
                    children: label
                }),
                descriptor
            ]
        })
    });
};
PromptListItem.displayName = 'PromptList.Item';

//# sourceMappingURL=PromptListItem.js.map